import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Estagio = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="ESTÁGIO OBRIGATÓRIO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Estágio Obrigatório" nome="obrigatorio" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />

                        {RenderCondicional()}
                    </div>

                    <HeaderVerde texto="ESTÁGIO NÃO OBRIGATÓRIO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Estágio Não Obrigatório" nome="naoobrigatorio" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />

                        {RenderCondicional2()}

                    </div>
                    <HeaderVerde texto="ESTAGIÁRIOS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantidade de Estagiário" nome="estagiarioqtd" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                        {RenderCondicional3()}
                    </div>
                </Caixa>
            )

            function RenderCondicional() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["obrigatorio"]
                if (array[modulo][n]["obrigatorio"] === "Sim") {
                    campos.push(
                        <>
                            <Select label="Termo de Compromisso de Estágio" nome="compromissoobg" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="Relação Nominal dos Supervisores/Docentes" nome="relacaonominalobg" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="Respeitada a Resolução de um Docente Supervisor Fisioterapeuta para até seis Acadêmicos " nome="docentesupervisor" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não", "Não se Aplica"]} />
                            <Select label="Respeitada a Resolução de um Docente Supervisor Fisioterapeuta para até três Estagiário " nome="supervisor" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não", "Não se Aplica"]} />
                            <HeaderVerde texto="Legalidade" />
                            <Select label="Conformidade com a Resolução COFFITO 431/13" nome="resolucao431" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />

                        </>
                    )
                }

                return campos
            }
            function RenderCondicional2() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["naoobrigatorio"]
                if (array[modulo][n]["naoobrigatorio"] === "Sim") {
                    campos.push(
                        <>
                            <Select label="Termo de Compromisso de Estágio" nome="compromisso" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />
                            <Select label="Relação Nominal dos Preceptores e Docentes" nome="relacaonominal" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />
                            <Select label="Respeitada a Resolução de um Preceptor Fisioterapeuta para até três Estagiários" nome="preceptor" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <HeaderVerde texto="Legalidade" />
                            <Select label="Conformidade com a Resolução COFFITO 432/13" nome="resolucao432" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />

                        </>
                    )
                }
                return campos
            }
            function RenderCondicional3() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["estagiarioqtd"]
                if (array[modulo][n]["estagiarioqtd"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Acadêmico" nome="academico" modulo={modulo} index={n}  subModulo="academico" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="57vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="RG" nome="rg" modulo={modulo} index={n}  subModulo="rg" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="CPF" nome="cpf" modulo={modulo} index={n} subModulo="cpf" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="IES" nome="ies" modulo={modulo} index={n} subModulo="ies" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="Período do Curso" nome="periodocurso" modulo={modulo} index={n} subModulo="periodocurso" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                              
                                <Select label="Modalidade do Estágio" nome="modalidade" modulo={modulo} index={n} subModulo="modalidade" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw"
                                    array={["Obrigatório", "Não Obrigatório"]} />
                              
                                <Select label="Dispõe de crachá fornecido pelo Crefito 1" nome="responsavel" modulo={modulo} index={n} subModulo="responsavel" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="19vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não", "Não se Aplica"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}
export default Estagio